import Swal from 'sweetalert2';

export class AlertHandler {
  constructor() {}

  public static SuccessAlert(title: any, ms?: number, customClass?: any) {
    Swal.fire({
      title: title,
      showConfirmButton: false,
      timer: ms || 2500,
      customClass: customClass || {
        title: 'text-base',
        icon: 'custom-icon-class',
      },
      iconHtml: '<img src="assets/images/save-alert.svg" style="width: 80px; height: 80px;" alt="Custom Icon">',
    });
  }

  public static SuccessUploadAlert(title: any, ms?: number, customClass?: any) {
    return Swal.fire({
      icon: 'success',
      title: title,
      showConfirmButton: false,
      showCloseButton: true,
      customClass: customClass || { title: 'text-base' },
    }).then(function () {
      return 'closed';
    });
  }

  public static deleteAlert(title: any, ms?: number, customClass?: any) {
    return Swal.fire({
      icon: 'question',
      title: title,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: '#2E2E38 ',
      cancelButtonColor: '#000',
      customClass: customClass || { title: 'text-base' },
    }).then((result) => {
      if (result.isConfirmed) {
        return 'confirm';
      } else {
        return 'cancel';
      }
    });
  }

  public static InfoAlert(title: any, ms?: number, customClass?: any) {
    Swal.fire({
      icon: 'info',
      title: title,
      showConfirmButton: false,
      timer: ms || 2500,
      customClass: customClass || { title: 'text-base' },
    });
  }

  public static WarningAlert(title: any, ms?: number, customClass?: any, enableTimer: boolean = true) {
    if (enableTimer) {
      Swal.fire({
        icon: 'warning',
        title: title,
        showConfirmButton: false,
        timer: ms || 2500,
        customClass: customClass || { title: 'text-base' },
      });
    } else {
      Swal.fire({
        icon: 'warning',
        title,
        showConfirmButton: true,
        customClass: customClass || { title: 'text-base' },
      });
    }
  }

  public static WarningUploadAlert(title: any, ms?: number, customClass?: any, enableTimer: boolean = true) {
    if (enableTimer) {
      Swal.fire({
        icon: 'warning',
        title: title,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: customClass || { title: 'text-base' },
      });
    } else {
      Swal.fire({
        icon: 'warning',
        title,
        showConfirmButton: true,
        customClass: customClass || { title: 'text-base' },
      });
    }
  }

  public static ErrorAlert(title: any, ms?: number, customClass?: any, enableTimer: boolean = true) {
    if (enableTimer) {
      Swal.fire({
        icon: 'error',
        title: title,
        showConfirmButton: false,
        timer: ms || 5000,
        customClass: customClass || { title: 'text-base' },
      });
    } else {
      Swal.fire({
        icon: 'error',
        title,
        showConfirmButton: true,
        customClass: customClass || { title: 'text-base' },
      });
    }
  }

  public static ErrorUploadAlert(title: any, ms?: number, customClass?: any, enableTimer: boolean = true) {
    if (enableTimer) {
      Swal.fire({
        icon: 'error',
        title: title,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: customClass || { title: 'text-base' },
      });
    } else {
      Swal.fire({
        icon: 'error',
        title,
        showConfirmButton: true,
        customClass: customClass || { title: 'text-base' },
      });
    }
  }

  public static DetailedErrorAlert(title: any, customClass?: any) {
    Swal.fire({
      icon: 'error',
      title: title,
      showConfirmButton: true,
      customClass: customClass || { title: 'text-base' },
    });
  }

  public static DetailedWarningAlert(title: any, customClass?: any) {
    Swal.fire({
      icon: 'warning',
      title: title,
      showConfirmButton: true,
      customClass: customClass || { title: 'text-base' },
    });
  }
}
